<div class="col-md-12">
  <nav class="navbar navbar-md mt-0 mb-2" style="left: 68%;">
      
  </nav>
  <div class="borderline"></div>
</div>		